const CaptureManager = {
    videoElement: null,
    stream: null,
    canvas: null,
    ctx: null,
    focusBox: null, 
    focusCtx: null,
    focusCanvas: null,
    snapshotAreaDiv: null,
    ocrCallData: {
        endpoint: null,
        customFormData: null,
        token: null,
    },
    gpuSession: {
        sessionExpiresAt: null,
        sessionCreator: null,
    },
    init: async function(canvas, datachipToken) {
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d', { alpha: false });
        this.setToken(datachipToken);
        console.log("CaptureManager.init, datachipToken: ", datachipToken);
        
        this.snapshotAreaDiv = canvas.parentElement.querySelector('.snapshots');
        if(!this.snapshotAreaDiv){
            //try parent of parent
            this.snapshotAreaDiv = canvas.parentElement.parentElement.querySelector('.snapshots');
            if(!this.snapshotAreaDiv){
                throw new Error('Snapshot area not found');
            }
        }
    },
    isCaptureInProgress: false,
    ocrInFlight: false,
    ocrFailStreak: 0,
    ocrRetryTimer: null,
    maxOcrFailStreak: 3,
    ocrRetryDelayMs: 1000,
    startCapture: async function() {
        var vm = this;
        var promise = new Promise(async (resolve, reject) => {
            try {
                vm.stream = await navigator.mediaDevices.getDisplayMedia({
                    video: {
                        cursor: "never",
                        displaySurface: "window"
                    },
                    preferCurrentTab: false,
                    surfaceSwitching: "exclude"
                });

                // Check if user selected a window (not a screen or tab)
                const videoTrack = vm.stream.getVideoTracks()[0];
                const settings = videoTrack.getSettings();
                if (settings.displaySurface && settings.displaySurface !== "window") {
                    vm.stream.getTracks().forEach(track => track.stop());
                    vm.stream = null;
                    reject("Please select a window, not a screen or browser tab.");
                    return;
                }

                if(!vm.videoElement) {
                    vm.videoElement = document.createElement('video');
                    vm.videoElement.style.display = 'none';
                    vm.canvas.parentElement.appendChild(vm.videoElement);
                }
                
                
                vm.videoElement.srcObject = vm.stream;
                vm.videoElement.muted = true;
                vm.videoElement.autoplay = true;
                vm.videoElement.onloadedmetadata = () => {
                    if(!vm.stream) return;

                    vm.videoElement.play();
                    vm.canvas.width = vm.videoElement.videoWidth;
                    vm.canvas.height = vm.videoElement.videoHeight;
                    requestAnimationFrame(() => vm.updateCanvas());
                    setTimeout(() => {
                        resolve();
                    }, 30);
                };
                
            } catch (err) {
                console.error("Error capturing screen:", err);
                //resolve(err.message);
                reject(err.message);
            }
        });
        return promise;
    },
    stopCapture: function() {
        // Stop monitoring interval if running
        this.stopMonitoring();

        if(this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }

        // Stop and clear video element
        if(this.videoElement) {
            this.videoElement.pause();
            this.videoElement.srcObject = null;
        }

        // Clear the canvas
        if(this.ctx && this.canvas) {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }

        //remove focusBox
        this.focusBox = null;
        this.focusCanvas = null;
        this.focusCtx = null;

        this.isCaptureInProgress = false;
    },
    stopMonitoring: function() {
        if (this.monitoringInterval) {
            clearInterval(this.monitoringInterval);
            this.monitoringInterval = null;
        }
        if (this.ocrRetryTimer) {
            clearTimeout(this.ocrRetryTimer);
            this.ocrRetryTimer = null;
        }
        this.ocrInFlight = false;
        this.ocrFailStreak = 0;
    },
    updateCanvas: function() {
        var vm = this;
        if (vm.videoElement && !vm.videoElement.paused) {
            // Get the video's native dimensions
            const videoWidth = vm.videoElement.videoWidth;
            const videoHeight = vm.videoElement.videoHeight;

            // Calculate scaling factors
            const scaleX = videoWidth / vm.canvas.width;
            const scaleY = videoHeight / vm.canvas.height;

            // Draw scaled version on main canvas
            vm.ctx.drawImage(vm.videoElement, 0, 0, vm.canvas.width, vm.canvas.height);

            // Bookmark: QUADRANTBOX (this is in two places)
            const quadrantBox = {
                x: 0,
                y: 0,
                width: vm.canvas.width / 2,
                height: vm.canvas.height / 1.5
            };

            // Draw slight green over the first quadrant
            vm.ctx.fillStyle = 'rgba(0, 255, 0, 0.15)';
            vm.ctx.fillRect(quadrantBox.x, quadrantBox.y, quadrantBox.width, quadrantBox.height);

            if (vm.focusBox) {

                // Bookmark: FOCUSBIAS (this is in two places)
                const biasBox = {
                    x: vm.focusBox.x + 50,
                    y: vm.focusBox.y + 50,
                    width: vm.focusBox.width * scaleX * 0.6,
                    height: vm.focusBox.height * scaleY * 0.5
                };


                // If focus box is out of the quadrant, 
                if (biasBox.x < quadrantBox.x || biasBox.y < quadrantBox.y || biasBox.x + biasBox.width > quadrantBox.x + quadrantBox.width || biasBox.y + biasBox.height > quadrantBox.y + quadrantBox.height)
                {

                    //draw red box, 2px wide
                    vm.ctx.strokeStyle = '#ff0000';
                    vm.ctx.lineWidth = 5;
                    vm.ctx.strokeRect(quadrantBox.x, quadrantBox.y, quadrantBox.width, quadrantBox.height);

                    vm.ctx.strokeStyle = '#ff0000';
                    vm.ctx.lineWidth = 4;
                    //dashed line
                    vm.ctx.setLineDash([10, 10]);
                    vm.ctx.strokeRect(biasBox.x, biasBox.y, biasBox.width, biasBox.height);
                }else{
               
                    vm.ctx.strokeStyle = '#00ff00';
                    vm.ctx.lineWidth = 5;
                    vm.ctx.strokeRect(quadrantBox.x, quadrantBox.y, quadrantBox.width, quadrantBox.height);

                    vm.ctx.strokeStyle = '#ff00ff';
                    vm.ctx.strokeRect(biasBox.x, biasBox.y, biasBox.width, biasBox.height);
                }


                if(vm.focusCtx){
                    vm.focusCtx.drawImage(vm.videoElement, vm.focusBox.x, vm.focusBox.y, vm.focusBox.width, vm.focusBox.height, 0, 0, vm.focusBox.width, vm.focusBox.height);
                }
            } else {
                // Only log occasionally to avoid spam
                if (Math.random() < 0.01) {
                    console.log("DEBUG updateCanvas: No focusBox to draw");
                }
            }
            requestAnimationFrame(() => vm.updateCanvas());
        }
    },
    setFocusBox: function(crop) {
        console.log("DEBUG CaptureManager.setFocusBox called with crop:", crop);

        if(crop == null) {
            console.log("DEBUG: crop is null, clearing focusBox");
            this.focusBox = null;
            this.focusCanvas = null;
            this.focusCtx = null;
            this.isCaptureInProgress = false;
            return;
        }

        console.log("DEBUG: crop properties - x:", crop.x, "y:", crop.y, "width:", crop.width, "height:", crop.height);

        this.focusBox = {
            x: Math.max(0, crop.x-20),
            y: Math.max(0, crop.y-20),
            width: crop.width+40,
            height: crop.height+20
        };

        console.log("DEBUG: Created focusBox object:", this.focusBox);
        console.log("DEBUG: Creating OffscreenCanvas with width:", this.focusBox.width, "height:", this.focusBox.height);


        this.focusCanvas = new OffscreenCanvas(this.focusBox.width, this.focusBox.height);
        this.focusCtx = this.focusCanvas.getContext('2d', { alpha: false });

        console.log("DEBUG: focusCanvas created:", this.focusCanvas);
        console.log("DEBUG: focusCtx created:", this.focusCtx);
        console.log("DEBUG: setting focusBox complete. Final state:", {
            focusBox: this.focusBox,
            focusCanvas: this.focusCanvas,
            focusCtx: this.focusCtx
        });
        this.isCaptureInProgress = true;
        console.log("DEBUG: isCaptureInProgress set to true");

    },

    addSnapshotToQueue: function(blob, resolve = null, reject = null) {
        // Create snapshot item with proper styling
        const snapshotItem = document.createElement('div');

        if(snapshotItem) {
            try {
                snapshotItem.className = 'snapshot-item processing';
                
                // Convert blob to background image URL and set it
                const imageUrl = URL.createObjectURL(blob);
                snapshotItem.style.backgroundImage = `url(${imageUrl})`;
                
                // Add to snapshot area
                const snapshotArea = this.snapshotAreaDiv.querySelector('.flex');
                snapshotArea.insertBefore(snapshotItem, snapshotArea.firstChild);

                // Remove oldest if exceeding max size
                const snapshots = snapshotArea.children;
                while (snapshots.length > RMS.maxQueueSize) {
                    const oldestSnapshot = snapshots[snapshots.length - 1];
                    // Clean up the URL object to prevent memory leaks
                    const oldBgImage = oldestSnapshot.style.backgroundImage.slice(4, -1).replace(/"/g, "");
                    URL.revokeObjectURL(oldBgImage);
                    snapshotArea.removeChild(oldestSnapshot);
                }
            } catch (error) {
                console.error('Failed to add snapshot to queue', error);
            }
        }

        // Process the image...
        this.processSnapshot(blob, snapshotItem, resolve, reject);
    },

    monitoringInterval: null,
    startMonitoring: function(captureTickCallback, newSnapshotCallback) {

        const captureInterval = 500;
        const diffThresholdPerc = 1;
        const hugeChangeThresholdPerc = 50;
        const maxHugeStrikes = 3; // consecutive huge frames (~1.5s) before we give up

        let firstIgnore = true;
        let hugeChangeStrikes = 0;
        let cooldownAnnounced = false;

        var vm = this;
        if (vm.monitoringInterval) {
            clearInterval(vm.monitoringInterval);
            vm.monitoringInterval = null;
        }

        this.ocrFailStreak = 0;
        this.ocrInFlight = false;
        if (this.ocrRetryTimer) {
            clearTimeout(this.ocrRetryTimer);
            this.ocrRetryTimer = null;
        }

        console.log("startMonitoring, focusBox: ", this.focusBox, this.ctx, this.canvas, this.canvas.width, this.canvas.height);

        // Get initial image data
        vm.lastImageData = vm.ctx.getImageData(
            vm.focusBox.x,
            vm.focusBox.y,
            vm.focusBox.width,
            vm.focusBox.height
        ).data;

        vm.monitoringInterval = setInterval(async () => {
            if (!vm.focusBox) return;
            
            if(captureTickCallback)
                captureTickCallback();

            
            // Bookmark: FOCUSBIAS (this is in two places)
            const currentImageData = vm.ctx.getImageData(
                vm.focusBox.x + 50,
                vm.focusBox.y + 50,
                vm.focusBox.width * 0.6,
                vm.focusBox.height * 0.5
            ).data;
            
            // Calculate the difference percentage
            const diffPercentage = vm.calculateDifference(currentImageData, vm.lastImageData);
            
            // Only take snapshot if difference is significant (e.g., more than 1%)
            if (diffPercentage > diffThresholdPerc) {
                
                //TODO: HANDLE HUGE CHANGE: Changed pixels: 62239 out of 82000 total pixels
                if(firstIgnore) {
                    firstIgnore = false;
                    vm.lastImageData = currentImageData;
                    console.log("DEBUG: firstIgnore, skipping snapshot");
                    return;
                }
                if(diffPercentage > hugeChangeThresholdPerc) {
                    hugeChangeStrikes++;
                    console.log(`DEBUG: huge change (${diffPercentage.toFixed(2)}%), strike ${hugeChangeStrikes}/${maxHugeStrikes} - cooling down`);
                    // Re-baseline against this frame so the next tick measures whether the screen has settled.
                    vm.lastImageData = currentImageData;
                    // Subtle one-time cue so the player knows the droid noticed the churn.
                    if(!cooldownAnnounced && window.RMS && window.RMS.droidQueue) {
                        cooldownAnnounced = true;
                        window.RMS.droidQueue
                            .eye([255, 165, 0], 'pulseEye', 800)
                            .text("*wary warble* Whoa—hold steady...", 1.2);
                    }
                    if(hugeChangeStrikes >= maxHugeStrikes) {
                        window.endMonitoringSession(true, "The screen kept changing too drastically to read. Keep the capture region steady on your inventory and try again.");
                    }
                    return;
                }
                // Valid change - settled enough to snapshot; clear any accumulated strikes.
                hugeChangeStrikes = 0;
                if(cooldownAnnounced) {
                    cooldownAnnounced = false;
                    if(window.RMS && window.RMS.droidQueue) {
                        window.RMS.droidQueue.eye([0, 255, 255], 'pulseEye', 1500);
                    }
                }
                if(vm.ocrInFlight || vm.ocrRetryTimer) {
                    console.log("DEBUG: OCR in flight or waiting to retry - skipping extra snapshot");
                    return;
                }
                console.log('Difference exceeds threshold - taking snapshot', `Difference detected: ${diffPercentage.toFixed(2)}% / ${diffThresholdPerc.toFixed(2)}%`);
                vm.takeSnapshot();
                if(newSnapshotCallback)
                    newSnapshotCallback();
                vm.lastImageData = currentImageData;
            } else {
                // Screen is quiet again - reset strikes so only sustained chaos ends the session.
                hugeChangeStrikes = 0;
                if(cooldownAnnounced) {
                    cooldownAnnounced = false;
                    if(window.RMS && window.RMS.droidQueue) {
                        window.RMS.droidQueue.eye([0, 255, 255], 'pulseEye', 1500);
                    }
                }
            }
        }, captureInterval); // Check every second
    },  
    
    calculateDifference: function(currentData, lastData) {
        let diffCount = 0;
        const totalPixels = currentData.length / 4;
        
        // Compare each pixel's RGB values (ignore alpha)
        for (let i = 0; i < currentData.length; i += 4) {
            const diffR = Math.abs(currentData[i] - lastData[i]);
            const diffG = Math.abs(currentData[i + 1] - lastData[i + 1]);
            const diffB = Math.abs(currentData[i + 2] - lastData[i + 2]);
            
            // If any color channel has changed by more than 10 (out of 255), count it as a change
            if (diffR > 10 || diffG > 10 || diffB > 10) {
                diffCount++;
            }
        }
        
        const percentage = (diffCount / totalPixels) * 100;
        // Log detailed information about the changes
        if (percentage > 0) {
            console.log(`Changed pixels: ${diffCount} out of ${totalPixels} total pixels`);
        }
        
        return percentage;
    },
    setToken: function(token) {
        this.ocrCallData.token = token;
    },
    setCaptureData: function(customFormData, endpoint, captureResultCallback) {
        this.ocrCallData.customFormData = customFormData;
        this.ocrCallData.endpoint = endpoint; // typically /process-invdata-snap
        this.captureResultCallback = captureResultCallback;
    },
    takeSnapshot: function(callback = null, callbackError = null) {
        if (!this.focusBox || !this.videoElement) return;
        if (this.ocrInFlight) {
            console.log("DEBUG: takeSnapshot skipped — OCR already in flight");
            return;
        }

        this.ocrInFlight = true;
        this.focusCanvas.convertToBlob({ type: 'image/png', quality: 1.0 }).then((blob) => {
            if (!blob) 
                throw new Error('Failed to create blob from canvas');
            
            this.addSnapshotToQueue(blob, callback, callbackError);
        }).catch((error) => {
            console.error('Failed to create blob from canvas', error);
            this.ocrInFlight = false;
            if(callbackError)
                callbackError(error);
            this.handleOcrFailure(error);
        });
    },
    handleOcrFailure: function(error) {
        // Only auto-retry / abort while a monitoring session is running.
        if (!this.monitoringInterval) return;

        this.ocrFailStreak++;
        const streak = this.ocrFailStreak;
        const max = this.maxOcrFailStreak;
        console.error(`OCR failed (${streak}/${max}):`, error);

        if (streak >= max) {
            if (window.endMonitoringSession) {
                window.endMonitoringSession(true, "Couldn't read the inventory after 3 tries. Keep the resource window visible and try again.");
            }
            return;
        }

        if (window.RMS && window.RMS.droidQueue) {
            window.RMS.droidQueue
                .eye([255, 140, 0], 'pulseEye', 700)
                .text(`*confused beeps* Can't read that—retrying (${streak}/${max})...`, 1.2);
        }

        if (this.ocrRetryTimer) {
            clearTimeout(this.ocrRetryTimer);
        }
        this.ocrRetryTimer = setTimeout(() => {
            this.ocrRetryTimer = null;
            if (!this.focusBox || !this.stream || !this.monitoringInterval) return;
            this.takeSnapshot();
        }, this.ocrRetryDelayMs);
    },
    processSnapshot: async function(blob, snapshotItem, resolve = null, reject = null) {
        try {
            const formData = new FormData();
            formData.append('image', blob);

            if(this.ocrCallData.customFormData) {
                const data = typeof this.ocrCallData.customFormData === 'function' 
                    ? this.ocrCallData.customFormData() 
                    : this.ocrCallData.customFormData;
                console.log("customFormData: ", data);
                for(const [key, value] of Object.entries(data)) {
                    formData.append(key, value);
                }
            }
            
            const response = await fetch(this.ocrCallData.endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.ocrCallData.token}`
                },
                body: formData
            });
            
            const result = await response.json();
            if (!result.success) {
                throw new Error(result.error);
            }

            this.ocrFailStreak = 0;
    
            // Check session expiration
            if (result.sessionExpiresAt) {
                const expiresAt = new Date(result.sessionExpiresAt);
                const timeRemaining = Math.max(0, Math.floor((expiresAt - new Date()) / 1000 / 60));
                this.gpuSession.sessionExpiresAt = expiresAt;
                this.gpuSession.sessionCreator = result.sessionCreator;
    
                if (timeRemaining <= 5 && window.RMS && window.RMS.droidQueue) {
                    window.RMS.droidQueue.clear()
                        .eye([255, 165, 0], 'pulseEye', 1000)
                        .text(`*concerned beeps* Warning: ${result.sessionCreator}'s session expires in ${timeRemaining} minutes!`, 2)
                        .wait(2000);
                }
            }
    
            if(snapshotItem) {
                // Update snapshot status to processed
                snapshotItem.classList.remove('processing');
                snapshotItem.classList.add('processed');
            }
            
            if(resolve){
                console.log("result (resolve): ", result);
                resolve(result.captureData || result);
            } else if(this.captureResultCallback) {
                console.log("result (callback): ", result);
                this.captureResultCallback(result.captureData || result);
            }
        } catch (error) {
            if(reject)
                reject(error);
            console.error('Processing error:', error);
            if(snapshotItem) {
                snapshotItem.classList.remove('processing');
                snapshotItem.classList.add('error');
            }
            this.handleOcrFailure(error);
        } finally {
            this.ocrInFlight = false;
        }
    }
    
};


window.CaptureManager = CaptureManager;